import logo from "assets/images/brands/brand-main-sm.png";
import whitLogo from "assets/images/brands/brand-main-sm-light.png";
import hLogo from "assets/images/brands/brand-main-sm.png";

export const clientName = "EM";
export const developedBy = "EM";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "EM";
export const companyWebsite = "#";
export const privacyPolicyLink = "https://em-markets.com/ar/privacy-policy";
export const clientAgreementLink = "/files/agreement.pdf";
export const sidebarLogo = hLogo;
export const smLogo = logo;
export const lightLogo = whitLogo;
export const mainLogo = hLogo;
export const footerLogo = logo;
